import AbstractNode from './AbstractNode';

export default class CardContent extends AbstractNode {
    get name() {
        return "card_content";
    }

    get schema() {
        return {
            content: "card_content_header card_content_meta? card_content_description?",
            parseDOM: [{
                tag: '.ui.card .content'
            }],
            defining: true,
            draggable: false,
            toDOM: () => ["div", {'class': 'content'}, 0]
        }
    }

    toMarkdown(state, node) {
        state.write('<div class="content">');
        state.ensureNewLine();
        state.renderContent(node);
        state.write('</div>');
        state.ensureNewLine();
    }

    get parseMarkdown() {
        return {
            block: "card_content"
        }
    }
}